export default function ProductCard({ product }) {
  return (
    <div className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-xl transition">
      <img
        src={product.image}
        alt={product.name}
        className="w-full h-48 object-cover"
      />

      <div className="p-4">
        <h3 className="text-lg font-semibold">{product.name}</h3>
        <p className="text-sm text-gray-500">{product.material}</p>

        <p className="font-bold mt-2">₹{product.price}</p>

        <p className="text-sm mt-2">{product.description}</p>

        <button className="mt-3 w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">
          Request Quote
        </button>
      </div>
    </div>
  );
}
